var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "search-btn-hide": true,
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          stripe: false,
          selection: _vm.hasBtn && _vm.selection,
          "right-toolbar-hide": "",
        },
        on: { handleSelectionChange: _vm.handleSelectionChange },
        scopedSlots: _vm._u([
          {
            key: "tableColumn",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    prop: "skuName",
                    label: _vm.$t("goodsPage.skuName"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "standardSkuCode",
                    label: _vm.$t("OrdinaryOrderMix.GoodsInfoTab.SKU"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.toView(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.standardSkuCode))]
                          ),
                          _c("BjCopyIcon", {
                            attrs: { copy: scope.row.standardSkuCode },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "spuCode",
                    label: _vm.$t("OrdinaryOrderMix.OrderItemTable.SPU"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "quantity",
                    label: _vm.$t("OrdinaryOrderMix.GoodsInfoTab.Quantity"),
                    align: "center",
                  },
                }),
                _vm.businessType == _vm.ORDER_BUSINESS_TYPES.COMMON
                  ? [
                      _c("el-table-column", {
                        attrs: {
                          prop: "preemptionStatus",
                          label: _vm.$t(
                            "OrdinaryOrderMix.GoodsInfoTab.occupied"
                          ),
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          _vm.ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST.bjGet(
                                            scope.row.preemptionStatus
                                          )
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2148464719
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "sourceStatus",
                          label: _vm.$t(
                            "OrdinaryOrderMix.GoodsInfoTab.Sourcing"
                          ),
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          _vm.ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(
                                            scope.row.sourceStatus
                                          )
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3590935911
                        ),
                      }),
                    ]
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("viewDialog", { ref: "viewDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }